import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import EmptyStates from '../empty-states';
import withPermissions from '../../hoc/with-permissions';
import withTranslate from '../../../common/components/with-translate/with-translate';
import styles from './no-posts-filtered.scss';

class NoPostsFiltered extends React.Component {
  render() {
    const { t, category, type, noMemberPosts, ...rest } = this.props;
    return (
      <EmptyStates
        className={styles.container}
        title={t(noMemberPosts ? 'no-filtered-member-posts.title' : 'no-filtered-posts.title')}
        content={t(
          noMemberPosts
            ? 'no-filtered-member-posts.reset-your-filter'
            : 'no-filtered-posts.reset-your-filter',
        )}
        type={type}
        {...rest}
      ></EmptyStates>
    );
  }
}

NoPostsFiltered.propTypes = {
  category: PropTypes.object,
  t: PropTypes.func,
  type: PropTypes.string,
  noMemberPosts: PropTypes.bool,
};

export default flowRight(withPermissions, withTranslate)(NoPostsFiltered);
